import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { queryKeys } from './queryKeys';
import { bmiService } from '../services/api/bmi-service.js';

// Body measurements are patient clinical data: never persisted to browser storage
// and not kept in memory once the consultation view is gone.
const CLINICAL_QUERY_META = { persist: false, isSensitive: true };

export function bmiMeasurementsQueryOptions(appointmentId, limit) {
  return {
    queryKey: queryKeys.bmi.byAppointment(appointmentId, limit),
    queryFn: ({ signal }) => bmiService.fetchMeasurements(appointmentId, { limit, signal }),
    enabled: Boolean(appointmentId),
    staleTime: 0,
    gcTime: 0,
    refetchOnWindowFocus: false,
    meta: CLINICAL_QUERY_META,
  };
}

export function useBmiMeasurements(appointmentId, limit) {
  return useQuery(bmiMeasurementsQueryOptions(appointmentId, limit));
}

export function useSaveBmiMeasurement(appointmentId) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (values) => bmiService.saveMeasurement(appointmentId, values),
    meta: CLINICAL_QUERY_META,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: queryKeys.bmi.appointment(appointmentId) }),
  });
}
